export class OneToNEnroll {
  id!: string;
  status!: boolean;
  enrolled!: boolean;
  message!: string;
  error!: string;
  processTime!: number;
  user?: any;
}
